module.exports = __webpack_public_path__ + "static/media/pinterest-brands.74f3c20a.svg";